import { useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import '../assets/styles/Navbar.css'
import Logo from '../assets/images/Buddy.png'

const Navbar = () => {
    const [servicesOpen, setServicesOpen] = useState(false)
    const [productsOpen, setProductsOpen] = useState(false)
    const [isNavCollapsed, setIsNavCollapsed] = useState(true)

    const location = useLocation()
    const isDesktop = window.innerWidth >= 992

    const closeAllMenus = () => {
        setServicesOpen(false)
        setProductsOpen(false)
        setIsNavCollapsed(true)
    }

    return (
        // fixed-top
        <nav className="navbar navbar-expand-lg navbar-dark bg-dark "> 
            <div className="container">
                <Link className="navbar-brand" to="/"><img src={Logo} alt="Logo Imahe" className="header-logo-img" /></Link>

                <button
                    className="navbar-toggler"
                    type="button"
                    onClick={() => setIsNavCollapsed(!isNavCollapsed)}
                >
                    <span className="navbar-toggler-icon" />
                </button>

                <div className={`collapse navbar-collapse ${!isNavCollapsed ? 'show' : ''}`}>
                    <ul className="navbar-nav mx-auto">

                        <li className="nav-item">
                            <Link className={`nav-link ${location.pathname === '/' ? 'active' : ''}`} to="/" onClick={closeAllMenus}>Home</Link>
                        </li>

                        <li className="nav-item">
                            <Link className={`nav-link ${location.pathname === '/about' ? 'active' : ''}`} to="/about" onClick={closeAllMenus}>About Us</Link>
                        </li>

                        {/* Services Dropdown */}
                        <li
                            className={`nav-item dropdown ${servicesOpen ? 'show' : ''}`}
                            onMouseEnter={() => isDesktop && setServicesOpen(true)}
                            onMouseLeave={() => isDesktop && setServicesOpen(false)}
                        >
                            <span
                                className="nav-link dropdown-toggle"
                                role="button"
                                onClick={() => !isDesktop && setServicesOpen(!servicesOpen)}
                            >
                                Services
                            </span>
                            <ul className={`dropdown-menu mega-menu ${servicesOpen ? 'show' : ''}`}>
                                <li><Link className="dropdown-item" to="/services/development" onClick={closeAllMenus}>Development</Link></li>
                                <li><Link className="dropdown-item" to="/services/graphics" onClick={closeAllMenus}>Graphics Designing</Link></li>
                                <li><Link className="dropdown-item" to="/services/uiux" onClick={closeAllMenus}>UI/UX Designing</Link></li>
                                <li><Link className="dropdown-item" to="/services/constructions" onClick={closeAllMenus}>Constructions</Link></li>
                                <li><Link className="dropdown-item" to="/services/mis" onClick={closeAllMenus}>MIS Executive</Link></li>
                                <li><Link className="dropdown-item" to="/services/marketing" onClick={closeAllMenus}>Marketing</Link></li>
                            </ul>
                        </li>

                        {/* Products Dropdown */}
                        <li
                            className={`nav-item dropdown ${productsOpen ? 'show' : ''}`}
                            onMouseEnter={() => isDesktop && setProductsOpen(true)}
                            onMouseLeave={() => isDesktop && setProductsOpen(false)}
                        >
                            <span
                                className="nav-link dropdown-toggle"
                                role="button"
                                onClick={() => !isDesktop && setProductsOpen(!productsOpen)}
                            >
                                Products
                            </span>
                            <ul className={`dropdown-menu ${productsOpen ? 'show' : ''}`}>
                                <li><Link className="dropdown-item" to="/products/crm" onClick={closeAllMenus}>CRM</Link></li>
                                <li><Link className="dropdown-item" to="/products/erp" onClick={closeAllMenus}>ERP</Link></li>
                            </ul>
                        </li>

                        <li className="nav-item">
                            <Link className={`nav-link ${location.pathname === '/contact' ? 'active' : ''}`} to="/contact" onClick={closeAllMenus}>Contact Us</Link>
                        </li>

                    </ul>
                    <div className="announcement-wrapper">
                        <p className="typewriter-text caveat">🚀 Launching This July 🚀</p>
                    </div>
                </div>
            </div>
        </nav>
    )
}

export default Navbar
